export default __webpack_public_path__ + "static/media/01.b6845e5e.webp";